
import { Container, Row, Col, Form, Button } from "react-bootstrap"
import { Link } from "react-router-dom"
import "../pages/styled/Contact.css"
import contactbanner from "../assets/productsec/contactbanner.jpeg";
function Contact() {
  return (
    <>
 
<div
  className="contact-header"
  style={{
    backgroundImage: `url(${contactbanner})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "300px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  }}
>
  <div className="header-content">
    <h1
      className="header-title"
      style={{
        fontSize: "3rem",
        fontWeight: "bold",
        color: "white",
        textTransform: "uppercase",
      }}
    >
      CONTACT US
    </h1>
  </div>
</div>


      <Container className="py-5">
        <Row className="mb-5 text-center">
          <Col lg={8} className="mx-auto">
            <h2 className="section-title">Get in Touch With Our Cleaning Experts</h2>
            <div className="divider mx-auto"></div>
            <p className="lead">
              Have questions about our cleaning services? Need a customized cleaning solution for your home or business?
              Our team is ready to assist you with all your cleaning needs.
            </p>
          </Col>
        </Row>

        <Row className="g-5">
          <Col lg={5}>
            <h3 className="fw-bold mb-4">Contact Information</h3>

            <div className="contact-info-item mb-4">
              <div className="d-flex">
                <div
                  className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ width: "50px", height: "50px", flexShrink: 0 }}
                >
                  <i className="bi bi-geo-alt-fill fs-4"></i>
                </div>
                <div>
                  <h5 className="fw-bold">OFFICE LOCATION</h5>
                  <p className="text-muted">No.62A, Thiruvalluvar St, Jagathambigai Nagar, Padi, Chennai-600 050.</p>
                </div>
              </div>
            </div>

            <div className="contact-info-item mb-4">
              <div className="d-flex">
                <div
                  className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ width: "50px", height: "50px", flexShrink: 0 }}
                >
                  <i className="bi bi-telephone-fill fs-4"></i>
                </div>
                <div>
                  <h5 className="fw-bold">PHONE</h5>
                  <p className="text-muted">+91 86085  98089</p>
                </div>
              </div>
            </div>

            <div className="contact-info-item mb-4">
              <div className="d-flex">
                <div
                  className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ width: "50px", height: "50px", flexShrink: 0 }}
                >
                  <i className="bi bi-phone-fill fs-4"></i>
                </div>
                <div>
                  <h5 className="fw-bold">MOBILE</h5>
                  <p className="text-muted">+91 87544   72227</p>
                </div>
              </div>
            </div>

            <div className="contact-info-item mb-4">
              <div className="d-flex">
                <div
                  className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ width: "50px", height: "50px", flexShrink: 0 }}
                >
                  <i className="bi bi-envelope-fill fs-4"></i>
                </div>
                <div>
                  <h5 className="fw-bold">EMAIL</h5>
                  <p className="text-muted mb-0">sales@sunshiny.co.in</p>
                  <p className="text-muted">info@sunshiny.co.in</p>
                </div>
              </div>
            </div>

            <div className="contact-info-item">
              <h5 className="fw-bold mb-3">BUSINESS HOURS</h5>
              <ul className="list-unstyled">
                <li className="d-flex justify-content-between mb-2">
                  <span>Monday - Friday:</span>
                  <span className="text-muted">9:00 AM - 6:00 PM</span>
                </li>
                <li className="d-flex justify-content-between mb-2">
                  <span>Saturday:</span>
                  <span className="text-muted">9:00 AM - 5:00 PM</span>
                </li>
                <li className="d-flex justify-content-between">
                  <span>Sunday:</span>
                  <span className="text-muted">Closed</span>
                </li>
              </ul>
            </div>

            <div className="mt-4">
              <h5 className="fw-bold mb-3">CONNECT WITH US</h5>
              <div className="d-flex gap-2">

              <Link to="https://www.facebook.com/profile.php?id=61558188570189#" target="_blank"
              className="bg-primary text-white d-flex align-items-center justify-content-center rounded-circle"
              style={{ width: "40px", height: "40px" }}>
               <i className="bi bi-facebook"></i>
               </Link> 

              

              <Link to="https://www.instagram.com/sunshinyenterprises/"  target="_blank"
              className="bg-primary text-white d-flex align-items-center justify-content-center rounded-circle"
              style={{ width: "40px", height: "40px" }}>
              <i className="bi bi-instagram"></i>
               </Link> 

               <Link to="https://www.linkedin.com/in/sun-shiny-enterprises-schoon-862a78278/"   target="_blank"
              className="bg-primary text-white d-flex align-items-center justify-content-center rounded-circle"
              style={{ width: "40px", height: "40px" }}>
              <i className="bi bi-linkedin"></i>
               </Link> 
                           {/* <a
                  href="#"
                  className="bg-primary text-white d-flex align-items-center justify-content-center rounded-circle"
                  style={{ width: "40px", height: "40px" }}
                >
                  <i className="bi bi-twitter"></i>
                </a> */}
              </div>
            </div>
          </Col>

          <Col lg={7}>
            <div className="contact-form-container p-4 p-md-5 bg-white rounded shadow-sm">
              <h3 className="fw-bold mb-4">Request a Cleaning Quote</h3>
              <Form>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Full Name</Form.Label>
                      <Form.Control type="text" placeholder="Your name" />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control type="email" placeholder="Your email" />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control type="tel" placeholder="Your phone" />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Property Type</Form.Label>
                      <Form.Select>
                        <option>Residential</option>
                        <option>Commercial</option>
                        <option>Industrial</option>
                        <option>Other</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label>Service Needed</Form.Label>
                  <Form.Select>
                    <option>Regular Cleaning</option>
                    <option>Deep Cleaning</option>
                    <option>Post-Construction Cleaning</option>
                    <option>Office Cleaning</option>
                    <option>Carpet & Upholstery Cleaning</option>
                    <option>Window Cleaning</option>
                    <option>Sanitization Services</option>
                    <option>Other</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Property Size (sq. ft.)</Form.Label>
                  <Form.Control type="text" placeholder="Approximate size" />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>Additional Information</Form.Label>
                  <Form.Control as="textarea" rows={5} placeholder="Tell us more about your cleaning needs" />
                </Form.Group>

                <Button variant="danger" type="submit" className="px-4 py-2">
                  Submit Request
                </Button>
              </Form>
            </div>
          </Col>
        </Row>

        <div className="mt-5">
          <h3 className="fw-bold mb-4">Our Location</h3>
          <div className="ratio ratio-21x9" style={{ maxHeight: "400px" }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.0!2d80.2!3d13.1!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTPCsDA2JzAwLjAiTiA4MMKwMTInMDAuMCJF!5e0!3m2!1sen!2sin!4v1615000000000!5m2!1sen!2sin"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>
        </div>

        <div className="mt-5">
          <h3 className="section-title text-center">Frequently Asked Questions</h3>
          <div className="divider mx-auto mb-4"></div>
          <Row className="g-4">
            <Col md={6}>
              <div className="faq-item">
                <h5 className="fw-bold">What areas do you service?</h5>
                <p className="text-muted">
                  We provide cleaning services throughout Chennai and surrounding areas within a 30km radius.
                </p>
              </div>
            </Col>
            <Col md={6}>
              <div className="faq-item">
                <h5 className="fw-bold">Are your cleaning products safe?</h5>
                <p className="text-muted">
                  Yes, we use eco-friendly, non-toxic cleaning products that are safe for children, pets, and the
                  environment.
                </p>
              </div>
            </Col>
            <Col md={6}>
              <div className="faq-item">
                <h5 className="fw-bold">How do you price your cleaning services?</h5>
                <p className="text-muted">
                  Our pricing is based on the size of the space, type of cleaning required, and frequency of service. We
                  provide free quotes after assessing your specific needs.
                </p>
              </div>
            </Col>
            <Col md={6}>
              <div className="faq-item">
                <h5 className="fw-bold">Do I need to be present during the cleaning?</h5>
                <p className="text-muted">
                  No, you don't need to be present. We can arrange for key pickup and drop-off, or you can provide
                  access instructions.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  )
}

export default Contact

